import type { MarketAccount } from '@talos/kyoko';
import type { PredictionMarketsPriceGridFilterState } from './types';

export function getPredictionMarketsPriceGridMarket(
  filterState: PredictionMarketsPriceGridFilterState
): string | undefined {
  return filterState.market;
}

export function getPredictionMarketsPriceGridMarketAccount(
  filterState: PredictionMarketsPriceGridFilterState
): string | undefined {
  return filterState.marketAccount;
}

export function setPredictionMarketsPriceGridSelections(
  filterState: PredictionMarketsPriceGridFilterState,
  market: string | undefined,
  marketAccount: string | undefined
): PredictionMarketsPriceGridFilterState {
  return {
    ...filterState,
    market,
    marketAccount,
  };
}

export function resolvePredictionMarketsPriceGridMarket(
  preferred: string | undefined,
  supportedMarkets: readonly string[]
): string | undefined {
  if (preferred && supportedMarkets.includes(preferred)) {
    return preferred;
  }
  return supportedMarkets.find(market => market === 'kalshi') ?? supportedMarkets.at(0);
}

export function resolvePredictionMarketsPriceGridMarketAccount(
  preferred: string | undefined,
  options: MarketAccount[],
  configuredDefault: string | undefined
): string | undefined {
  const optionNames = new Set(options.map(option => option.Name));
  if (preferred && optionNames.has(preferred)) {
    return preferred;
  }
  if (configuredDefault && optionNames.has(configuredDefault)) {
    return configuredDefault;
  }
  return options.at(0)?.Name;
}
